import styles from "./BrandsMarquee.module.css"

// Marka logolarını sonsuz kaydırılan bir şerit halinde gösteren bileşen.

export default function BrandsMarquee() {
  // Marka logolarını src/assets/images/Brands_Logos klasöründen yükle
  const req = require.context("../../assets/images/Brands_Logos", false, /\.(png|jpe?g|webp|gif|svg)$/)
  // Logolar dizisini oluştur ve sırala
  const logos = req.keys().sort().map(req)
  
  return (
    <section className="section white">
      <div className="container">
        {/* Bölüm başlığı */}
        <h2 className={`centerTitle ${styles.brandsTitle}`}>Exclusively First-Class Brands</h2>
        {/* Sonsuz kaydırılan marka şeridi */}
        <div className={styles.marquee}>
          {/* Track - görselleri iki kez render et (sonsuz döngü için) */}
          <div className={styles.track}>
            {[...logos, ...logos].map((src, i) => (
              <div className={styles.brand} key={i}>
                <img src={src || "/placeholder.svg"} alt={`Brand ${i + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
